var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { title: "Register Accessory", placement: "left" },
      on: { hide: _vm.resetForm },
      model: {
        value: _vm.addModal.visible,
        callback: function ($$v) {
          _vm.$set(_vm.addModal, "visible", $$v)
        },
        expression: "addModal.visible",
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.accessoryForm.loading,
                  expression: "accessoryForm.loading",
                },
              ],
              ref: "accessoryForm",
              staticClass: "register-accessory__form",
              attrs: { model: _vm.accessoryForm.model, rules: _vm.formRules },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Category", prop: "type" } },
                [
                  _c("RefreshProducts", {
                    staticStyle: { "padding-left": "7px" },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        "data-test-id": "accessory-type",
                        placeholder: "Select",
                      },
                      model: {
                        value: _vm.accessoryForm.model.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.accessoryForm.model, "type", $$v)
                        },
                        expression: "accessoryForm.model.type",
                      },
                    },
                    _vm._l(_vm.accessoryTypes, function (type) {
                      return _c("el-option", {
                        key: type,
                        attrs: { label: type, value: type },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Accessory", prop: "kind" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        "data-test-id": "accessory-kind",
                        placeholder: "Select",
                      },
                      model: {
                        value: _vm.accessoryForm.model.kind,
                        callback: function ($$v) {
                          _vm.$set(_vm.accessoryForm.model, "kind", $$v)
                        },
                        expression: "accessoryForm.model.kind",
                      },
                    },
                    _vm._l(
                      _vm.accessoryKinds[_vm.accessoryForm.model.type],
                      function (device) {
                        return _c("el-option", {
                          key: device.kind,
                          attrs: {
                            label: device.description,
                            value: device.kind,
                          },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Serial Number", prop: "id" } },
                [
                  _c("el-input", {
                    attrs: { "data-test-id": "accessory-id" },
                    model: {
                      value: _vm.accessoryForm.model.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.accessoryForm.model, "id", $$v)
                      },
                      expression: "accessoryForm.model.id",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.accessoryForm.failed.state
            ? _c(
                "div",
                { staticClass: "add-new-accessory__alert" },
                _vm._l(
                  _vm.accessoryForm.failed.messages,
                  function (msg, index) {
                    return _c("el-alert", {
                      key: index,
                      attrs: {
                        type: "error",
                        description: msg,
                        "show-icon": "",
                      },
                      domProps: { innerHTML: _vm._s(msg) },
                    })
                  }
                ),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", margin: "0" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "text" },
                  on: { click: _vm.resetAndCloseForm },
                },
                [_vm._v("\n        cancel\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "mini",
                    "data-test-id": "confirm-btn",
                  },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("\n        confirm\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("a", { attrs: { slot: "reference" }, slot: "reference" }, [
        _vm._v("Add New"),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }